import React, { useCallback, useState } from 'react';
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider
} from '@stripe/react-stripe-js';
import { stripePromise } from './stripe';
import { createCheckoutSession } from '../../services/checkout.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Feedback from '../Feedback';

const CheckoutForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const accountLevel = searchParams.get('accountLevel');
  const [error, setError] = useState(false);

  if (!accountLevel) {
    navigate('/account/subscription');
    return null;
  }

  const fetchClientSecret = useCallback(async () => {
    const res = await createCheckoutSession(accountLevel);
    if (res.success && res.data) {
      const data = res.data!;
      return data.clientSecret;
    } else {
      setError(true);
      return '';
    }
  }, []);

  const options = { fetchClientSecret };

  if (error) {
    return (
      <Feedback
        message={
          'There was a problem getting to the checkout.  Please try again.'
        }
        type="error"
      />
    );
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default CheckoutForm;
